import { render, staticRenderFns } from "./stockproduct.vue?vue&type=template&id=2c6c86d6&scoped=true&"
import script from "./stockproduct.vue?vue&type=script&lang=js&"
export * from "./stockproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6c86d6",
  null
  
)

export default component.exports